// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23dlQ","buttons":"styles_buttons__2rqgB"};